/* istanbul ignore file */
import { Meta } from './interfaces/Meta';

export class MetaServerService implements Meta {
  public meta = { href: '' };

  getMeta() {
    return this.meta;
  }
}
